import React, { useContext } from "react";
import "./AppHeader.css";
import "../styles/theme.css";
import { AuthContext } from "../context/AuthContext";

function AppHeader() {
  const { user, logout } = useContext(AuthContext);

  return (
    <header className="app-header">
      <div className="header-left">
        <div className="user-name">{user?.name}</div>
        <div className="user-email">{user?.email}</div>
      </div>

      <div className="header-right">
        <button className="logout-btn" onClick={logout}>Logout</button>
      </div>
    </header>
  );
}

export default AppHeader;
